export default __webpack_public_path__ + "static/media/execute_readyforexam.806121f1.png";